<template>
  <div class="discuss">
    <div class="discuss-comment" data-toggle="modal" data-target=".modal-discuss">
      <textarea
        class="secondary-color-txt"
        name
        id
        cols="30"
        rows="10"
        placeholder="Đặt câu hỏi tại đây"
      ></textarea>
      <div class="user-img">
        <img src="@/assets/images/user.png" alt />
      </div>
      <div class="tool-discuss display-flex">
        <button class="upload-img">
          <i class="fas fa-image"></i> Ảnh
        </button>
        <button class="upload-file">
          <img src="@/assets/img/icon-file.png" alt /> File
        </button>
        <button class="upload-exam">
          <img src="@/assets/img/icon-exam.png" alt /> Bài tập
        </button>
        <button class="upload-symbol">
          <img src="@/assets/img/icon-symbol.png" alt /> Ký hiệu
        </button>
      </div>
    </div>
    <div
      class="modal fade modal-discuss"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg comment-discuss">
        <div class="modal-content">
          <div class="top display-flex">
            <img src="@/assets/images/user.png" alt />
            <h3 class="font-size-14 primary-color-txt font-sanpro-semibold">Nguyễn Văn An</h3>
          </div>
          <div class="mid">
            <textarea name="" id="" cols="30" rows="5" placeholder="Viết thảo luận tại đây..."></textarea>
          </div>
          <div class="bot">
             <div class="tool-discuss display-flex">
                <button class="upload-img">
                  <i class="fas fa-image"></i> Ảnh
                </button>
                <button class="upload-file">
                  <img src="@/assets/img/icon-file.png" alt /> File
                </button>
                <button class="upload-exam">
                  <img src="@/assets/img/icon-exam.png" alt /> Bài tập
                </button>
                <button class="upload-symbol">
                  <img src="@/assets/img/icon-symbol.png" alt /> Ký hiệu
                </button>
            </div>
            <div class="btn-discuss display-flex">
              <button type="button" class="btn-close" data-dismiss="modal">Hủy</button>
              <button type="button" class="btn-upload" >Đăng</button>
            </div>
          </div>
        </div>
      </div>
  </div>
    <!-- <DiscussComment /> -->
    <div class="search display-flex justify-content-between">
      <div class="form">
        <form class="form-training">
          <input type="text" placeholder="Tìm kiếm" required="required" />
          <button type="submit">
            <i class="fa fa-search secondary-color-blue"></i>
          </button>
        </form>
      </div>
      <div class="form-group select-status">
        <select class="form-control" id="status">
          <option>Tất cả thành viên</option>
          <option>Chưa tham gia</option>
          <option>Đã hoàn thành</option>
        </select>
        <i class="fa fa-angle-down"></i>
      </div>
    </div>
    <!-- <CommentTab /> -->
    <div class="list-comment" v-for="(item, index) in listComments" :key="index">
      <div class="top display-flex">
        <img src="@/assets/images/user.png" alt />
        <div class="name">
          <h3 class="font-size-16 primary-color font-sanpro-semibold">{{item.name}}</h3>
          <span class="font-size-12 secondary-color-txt font-family-Semibold">{{item.createAt}}</span>
        </div>
      </div>
      <div class="dropdown dropdown-account">
                <button
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    class="dropdown-toggle"
                >
                    <i class="fas fa-ellipsis-h"></i>
                </button>
                <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                    <a href="javascript:;" class="dropdown-item" role="button">Xem thông tin</a>
                    <a href="javascript:;" class="dropdown-item" role="button">Rời lớp</a>
                    <a href="javascript:;" class="dropdown-item" role="button">Báo cáo</a>
                </div>
        </div>
      <div class="mid">
          <h4 class="font-size-16 font-family-Semibold primary-color-txt">{{item.comment}}</h4>
      </div>
      <div class="bot display-flex justify-content-between">
          <div class="bot-left display-flex">
              <a href="" class="font-size-14">01 lượt thích</a>
              <a href="" class="font-size-14">01 câu trả lời</a>
          </div>
          <div class="bot-right display-flex">
              <button><i class="fas fa-thumbs-up"></i> Thích</button>
              <button><i class="fas fa-comment-alt"></i> Trả lời</button>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
// import CommentTab from '@/components/comments/CommentTab'
import DiscussComment from "../detail/ContentSubject"
export default {
  name: "Discuss",
  components:{
    DiscussComment,
    // CommentTab
  },
  data(){
      return{
          listComments:[
              { "id": 1, "name": "Nguyễn Văn A", "createAt": "20:00 - 15/07/2019", "comment":"Meow meow meow"},
               { "id": 2, "name": "Nguyễn Văn B", "createAt": "20:00 - 15/07/2019", "comment":"Chip Chip Chip"},
                { "id": 3, "name": "Nguyễn Văn C", "createAt": "20:00 - 15/07/2019", "comment":"Mlem Mlem"},
                 { "id": 4, "name": "Nguyễn Văn D", "createAt": "20:00 - 15/07/2019", "comment":"Woof woof"},
                  { "id": 5, "name": "Nguyễn Văn E", "createAt": "20:00 - 15/07/2019", "comment":"Quack quack"},
                   { "id": 6, "name": "Nguyễn Văn F", "createAt": "20:00 - 15/07/2019", "comment":"Miao miaooo"},
                    { "id": 7, "name": "Nguyễn Văn G", "createAt": "20:00 - 15/07/2019", "comment":"Meow meow meow"},
                     { "id": 8, "name": "Nguyễn Văn H", "createAt": "20:00 - 15/07/2019", "comment":"Ec ec ec"},
          ]
      }
  }
};
</script>

<style lang="scss" scoped>
.discuss-comment {
  position: relative;
  textarea {
    width: 100%;
    height: 122px;
    resize: none;
    border-radius: 5px;
    padding: 12px 12px 12px 50px;
    border: 1px solid #d8d8d8;
  }
  .user-img {
    position: absolute;
    top: 10px;
    left: 10px;
    img {
      border-radius: 50%;
      height: 30px;
    }
  }
  ::placeholder {
    color: #879aa9;
  }
  .tool-discuss {
    position: absolute;
    bottom: 18px;
    left: 20px;

    button {
      color: #879aa9;
      border-radius: 20px;
      background: none;
      border: 0;
      height: 30px;
      img {
        height: 15px;
      }
    }
    .upload-img,
    .upload-file {
      width: 76px;
    }
    .upload-exam,
    .upload-symbol {
      width: 102px;
    }
  }
}
.search {
  margin-top: 20px;
  .form {
    height: 30px;
    width: 377px;
    .form-training {
      position: relative;
      button {
        position: absolute;
        top: 4px;
        z-index: 1;
        background-color: transparent;
        border: 0;
        color: #124abe;
        outline: 0;
        right: 13px;
        font-size: 14px;
      }
      input {
        border-radius: 20px;
        height: 30px;
        padding: 0 35px 0 12px;
        top: 0;
        left: 0;
        border: 0;
        color: #40505e;
        outline: 0;
        background-color: #f3f6fb;
        font-size: 15px;
        width: 100%;
        position: static;
      }
    }
  }
  .select-status {
    position: relative;
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      padding: 2px 30px 2px 10px;
      border: none;
      background: none;
      border-radius: 20px;
      height: 30px;
      font-size: 14px;
      color: #879aa9;
    }
    i {
      position: absolute;
      top: 7px;
      right: 8px;
      color: #879aa9;
    }
  }
}
.list-comment {
    border: 1px solid #d8d8d8;
    border-radius: 5px;
    padding: 12px 12px 3px 12px;
    margin-bottom: 18px;
    position: relative;
  .top {
    img {
      height: 30px;
      border-radius: 50%;
    }
    .name {
      margin-left: 10px;
      h3{
            margin-bottom: 1px;
      }
    }
  }
  .dropdown-account{
        position: absolute;
        top: 0px;
        right: 5px;
    }
    .dropdown button {
        width: 30px;
        background:none;
        color: #879AA9;
        font-size: 14px;
        text-align: center;
        border: 0px;
        padding-left: 0px;
        padding-right: 0px;
        border-radius: 30px;
        height: 30px;
        outline: 0;
    }
    .dropdown-item:hover,
    .dropdown-item:focus {
        color: #124abe;
        text-decoration: none;
        background: none;
    }
    .dropdown button:focus {
        background: none !important;
        color: #124ABE;
    }
    .dropdown-toggle::after {
        display:none;
    }
    .dropdown-menu {
        padding: 0rem 0 0.5rem;
        margin: 0.125rem 0 0;
        box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
        transform: translate3d(-95px, 30px, 0px) !important;
    }
  .mid{
        margin-top: 8px;
        border-bottom: 1px solid #f1f1f1;
        padding-bottom: 8px;
  }
  .bot{
      margin-top: 10px;
      .bot-left{
          a{
                color:#879AA9;
                margin-right: 10px;
          }
      }
      .bot-right{
          button{
                border: 0;
                background: none;
                color: #124ABE;
          }
      }
  }
}
.comment-discuss{
  .modal-content{
    padding:12px;
    // height:258px;
    .top{
      img{
          height: 30px;
          border-radius: 50%;
      }
      h3{
          margin-left: 10px;
          margin-top: 7px;
      }
    }
    .mid{
      textarea{
            width: 100%;
            border: 0;
            resize: none;
            color: #40505E;
      }
    }
    .bot{
      .btn-discuss{
        justify-content:flex-end;
        button{
          border: 0;
          border-radius: 20px;
        }
        .btn-close{
            margin-right: 10px;
            color: #124ABE;
            background: none;
        }
        .btn-upload{
          background: #124ABE;
          color: #fff;
          width: 110px;
        }
      }
      .tool-discuss {
        position: absolute;
        bottom: 10px;
        left: 20px;

        button {
          color: #879aa9;
          border-radius: 20px;
          background: none;
          border: 0;
          height: 30px;
          img {
            height: 15px;
          }
        }
        .upload-img,
        .upload-file {
          width: 76px;
        }
        .upload-exam,
        .upload-symbol {
          width: 102px;
        }
      }
    }
  }
}
@media (max-width: 768px){
    .search .form {
      width: 295px;
  }
  .comment-discuss .modal-content .bot .tool-discuss .upload-file {
      width: 60px;
  }
  .comment-discuss .modal-content .bot .tool-discuss .upload-symbol {
    width: 80px;
}
.comment-discuss .modal-content .bot .tool-discuss {
    left: 0px;
}
}
@media (max-width: 425px){
  .search .form {
      width: 210px;
  }
  .comment-discuss .modal-content .bot .tool-discuss {
      position: unset;
      margin-bottom: 10px;
  }
  

}
@media (max-width: 320px){
  .comment-discuss .modal-content .bot .tool-discuss button{
    font-size: 14px;
    i{
      font-size: 14px;
    }
}
.comment-discuss .modal-content .bot .tool-discuss button img {
    height: 10px;
}
.comment-discuss .modal-content .bot .tool-discuss .upload-symbol {
    width: 90px;
}
}
</style>